__webpack_require__.p = "/energy/water/paper/Geo_visualization/";